import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { commonComponentsRegistry } from '../registry/CommonRegistry';

const Container = commonComponentsRegistry.getLazyComponent('Container');

export const FullPageLayout = () => {
    return (
        <Suspense fallback={<></>}>
            <Container backgroundColor={'white'} mode={'fluid'} flexDirection={'column'}>
                <Outlet />
            </Container>
        </Suspense>
    );
};
